import { Organisation, Workspace } from "@/api/user/types";
import { createContext, useContext, useSyncExternalStore } from "react";
import { User } from "../api/user/types";
import { createStore } from "@/service/store.ts";

interface OrganisationContext {
  organisation: Organisation | null;
  workspace: Workspace | null;
}

export const OrganisationContext = createContext<OrganisationContext>({
  organisation: null,
  workspace: null,
});

interface UserContext {
  user: User | null;
}

export const UserContext = createContext<UserContext>({
  user: null,
});

export function useUser() {
  const { user } = useContext(UserContext);
  if (!user) {
    throw new Error("useUser called outside Provider");
  }
  return user;
}

export const workspaceStore = createStore<OrganisationContext>({
  workspace: null,
  organisation: null,
});

export const getWorkspace = () => {
  const { workspace, organisation } = workspaceStore.get();
  if (!workspace || !organisation) throw new Error("Workspace not set yet");
  return { workspace, organisation };
};

export function useWorkspace() {
  const { workspace, organisation } = useSyncExternalStore(
    workspaceStore.subscribe,
    workspaceStore.get
  );
  if (!workspace || !organisation) throw new Error("Workspace not set yet");
  return { workspace, organisation };
}
